// eslint-disable-next-line no-use-before-define
import React from 'react';
import { SVGWrapperContainer } from './style';
export const SVGWrapper = ({ svg }) => {
    return (React.createElement(SVGWrapperContainer, { className: "root-app_svg", dangerouslySetInnerHTML: { __html: svg } }));
};
//# sourceMappingURL=svg-wrapper.js.map